import type { Fund } from '@/hooks/useFunds';

/**
 * `{fund_code} - {fund_name}` — how a fund is named in every fund picker (the
 * posting `FundSelect`, the report `FundMultiSelect`) and the AP payment form.
 */
export const formatFundLabel = (fund: Pick<Fund, 'fund_code' | 'fund_name'>): string =>
  `${fund.fund_code} - ${fund.fund_name}`;
